import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import React, { FC, memo, useCallback } from 'react';
import { viewTexts } from '../../constants/view-texts';
import { logout } from '../../global-state/auth-state';

const vt = viewTexts.dialogs.logout;

interface Props {
  open: boolean;
  onClose: () => void;
}

export const LogoutDialog: FC<Props> = memo(
  ({ open, onClose }: Readonly<Props>) => {
    const cancelOnClick = useCallback(() => {
      onClose();
    }, [onClose]);

    const okOnClick = useCallback(() => {
      logout();
      onClose();
    }, [onClose]);

    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>{vt.title}</DialogTitle>
        <DialogContent>{vt.description}</DialogContent>
        <DialogActions>
          <Button onClick={cancelOnClick} color='default'>
            {vt.cancel}
          </Button>
          <Button onClick={okOnClick} color='primary' autoFocus>
            {vt.ok}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

LogoutDialog.displayName = 'LogoutDialog';
